module.exports = __webpack_public_path__ + "img/katong.4527961.png";